import React, {  useEffect } from 'react';



export const withScrollTop = () => (WrappedComponent: React.ComponentType) => {


    return (props: React.PropsWithChildren<any>) => {

        useEffect(() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }, []);

        return (
            <>
                <WrappedComponent {...props}>
                    {props.children}
                </WrappedComponent>

            </>
        );
    };

};






